import { UpdatePreferencesApiModel } from '../../../api/users/models/preferences.api.model';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class MediaDatabaseApiUserAccount {
    accountName: string;
    accountId: number;
    partnerReseller: string;
    apiKey: string;
    accessToken: string;
    clientId: string;
    userClientId: string;
    updatePreferences: UpdatePreferencesApiModel;
    selectedPreferredLanguage: DropdownOptionModel;
}
